import Skeleton from "@mui/material/Skeleton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

/** ระยะขอบแนวนอนของแท่ง placeholder · แนวตั้งเป็น 0 เพื่อให้แถวสูงเท่า rowHeight พอดี */
const CELL_PADDING = "0 6px";

interface PurchaseOrderSkeletonProps {
  /** ขนาดหน้าของรายการ เพื่อให้ placeholder มีจำนวนแถวเท่ากับคำตอบที่กำลังจะมาถึง */
  rows: number;
  columns: number;
  /** ความสูงของแถวจริง เพื่อไม่ให้ตารางขยับตอนข้อมูลมาถึง */
  rowHeight: number;
}

export default function PurchaseOrderSkeleton({
  rows,
  columns,
  rowHeight,
}: PurchaseOrderSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow
          key={rowIndex}
          sx={{ height: rowHeight, "& td, & th": { padding: CELL_PADDING } }}
        >
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <TableCell key={columnIndex}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
